import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { toggleItemInArray } from "utils/array";
import { apiRequest } from "services/api";
import { NavigateFunction } from "react-router";

export interface FilterStateModel {
  loading: boolean;
  error: any | null;
  selectedAttributes: string[];
  showFilter: boolean;
  showFilterSettings: boolean;
}

interface FilterStore extends FilterStateModel {
  showSettings: () => void;
  hideSettings: () => void;
  toggleSettings: () => void;
  filterAddAttribute: (uuid: string) => void;
  filterRemoveAttribute: (uuid: string) => void;
  filterClear: () => void;
  filterShow: () => void;
  filterHide: () => void;
  changeFilteringMethod: (newFilteringMethod: any, navigate: NavigateFunction) => Promise<void>;
}

export const useFilterStore = create<FilterStore>()(
  persist(
    (set, get) => ({
      loading: false,
      error: null,
      selectedAttributes: [],
      showFilter: true,
      showFilterSettings: false,

      showSettings: () => set({ showFilterSettings: true }),
      hideSettings: () => set({ showFilterSettings: false }),
      toggleSettings: () =>
        set((state) => ({ showFilterSettings: !state.showFilterSettings })),

      filterAddAttribute: (uuid) =>
        set((state) => ({
          selectedAttributes: toggleItemInArray(state.selectedAttributes, uuid),
        })),

      filterRemoveAttribute: (uuid) =>
        set((state) => ({
          selectedAttributes: toggleItemInArray(state.selectedAttributes, uuid),
        })),

      filterClear: () => set({ selectedAttributes: [], loading: false, error: null }),
      filterShow: () => set({ showFilter: true }),
      filterHide: () => set({ showFilter: false }),

      changeFilteringMethod: async (newFilteringMethod, navigate) => {
        try {
          await apiRequest({
            endpoint: "/my/user",
            method: "patch",
            payload: { filteringMethod: newFilteringMethod },
          });
          const { useNotificationStore } = await import("modules/notifications/store");
          useNotificationStore.getState().successNotification("Filtering method changed!");
          const { useUserStore } = await import("modules/user/store");
          await useUserStore.getState().loadMyUser(navigate);
          get().hideSettings();
        } catch {
          // error silently
        }
      },
    }),
    {
      name: "filter-store",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        selectedAttributes: state.selectedAttributes,
        showFilter: state.showFilter,
      }),
    }
  )
);
